export const isNumeric = (target: unknown): target is number => typeof target === 'number' || !isNaN(Number(target));
export const isObject = (value: unknown) => typeof value === 'object' && !Array.isArray(value) && value !== null;
